// TODO contendor pagina conozcanos.
// trae informacion del backend y llama a los componentes de presentacion pasandoles los datos pertinentes
import React, { useState, useEffect } from 'react';
import { render } from "react-dom";
import properties from 'properties-parser';
import SuccessMessage from '../../generalComponents/Message/SuccessMessage'

import {  animateScroll as scroll } from "react-scroll";
import Typography from '@material-ui/core/Typography'
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Collapse from '@material-ui/core/Collapse'
import Card from '@material-ui/core/Card'
import IconButton from '@material-ui/core/IconButton'
import CardContent from '@material-ui/core/CardContent'
import Pagination from 'material-ui-flat-pagination'
import Grid from '@material-ui/core/Grid'
import { ACCESS_TOKEN } from '../../../constants'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import LoadingSpinner from '../../generalComponents/loadingSpinner/LoadingSpinner.js'
import { ANIMAL_FILE_STATE } from '../../../constants/index'
import ErrorMsg from '../../generalComponents/Message/ErrorMessage'
import LinesEllipsis from 'react-lines-ellipsis'
import { Link } from 'react-router-dom'
import Avatar from '@material-ui/core/Avatar'
import autoLogout from '../../../generalFunctions/autoSignout'

import Divider from '@material-ui/core/Divider'
import Carousel from "../../generalComponents/Carousel/Carousel";
import "react-responsive-carousel/lib/styles/carousel.css";
import { Container, Row, Col } from "reactstrap";
import "./ScreenConozcanos.css";
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';


const useStyles = makeStyles({
//    card: {
//        width: '100%',
//        maxWidth: '650px',
//        maxHeight: '250px',
//        height: '100%',
//        marginBottom:'3%',
//        marginRight:'15px',
//        backgroundColor: 'rgba(0, 151, 200, 1)'
//
//    },
card: {
        maxWidth: '1150px',
        height: '98%',
        display: 'inline-block',
        marginTop: '3%',
        margin: '5px 5px 5px 5px',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        paddingBottom:'24px'

    },
    card1: {
        width: '100%',
        maxWidth: '400px',
        height: '100%',
        maxHeight: '250px',
        marginBottom:'3%',
        marginRight:'15px',
        backgroundColor: 'rgba(0, 151, 200, 1)',
  
    },
    cardGrande: {
        width: '100%',
        maxWidth: '650px',
        maxHeight: '250px',
        height: '100%',
        marginBottom:'3%',
        marginRight:'15px',
       backgroundColor: 'rgba(255, 255, 255, 0.7)'
        
    },
    cardTitleSpinner: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 'auto',
        marginBottom: 'auto',
        width: '100%',
        maxWidth: 1448,
        backgroundColor: 'rgba(255, 255, 255, 0.8)'
    },
    table: {
        padding: '9px 3px 9px 3px',
        margin: '3px',
        height: '10%',

    },
    text: {
        wordBreak: 'break-word',
        maxWidth: '100px'
    },
    textLong: {
        wordBreak: 'break-word',
        maxWidth: '100px'
    },
    fecha: {
        whiteSpace: 'nowrap'
    },
    hover: {
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, .8)'
        }
    },
    filter: {
        backgroundColor: 'rgba(255, 255, 255, 1)',
        position: 'fixed',
        top: '10',
        right: '0',
        '&:active': {
            backgroundColor: 'rgba(255, 255, 255, 1)'
        },
        '&:focus': {
            backgroundColor: 'rgba(255, 255, 255, 1)'
        },
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            borderColor: '#3EA91D'
        }
    },
    checkboxIcons: {
        color: '#20DD03'
    },
    checkboxIconsRed: {
        color: '#F53232'
    },
    checkboxText: {
        paddingLeft: '15px',
        color: '#757575'
    },
    checkboxContainer: {
        display: 'flex',
        alignContent: 'space-between'
    },
    root: {
        maxWidth: '261px',
        width: '100%',
        padding: '0px'
    },
    grid: {
        height: '92%',

    },
    title: {
         fontSize: '24px',
        color: '#3C810D',
        fontFamily: 'TovariSans'
    },
    title1: {
         fontSize: '26px',
        color: '#3C810D',
        fontFamily: 'TovariSans'
       
    },
    h6: {size: '1.132em',
    textAlign:'justify',
    fontFamily:'Source Sans Pro'},

    h7: {
    color: '#3C810D',
    fontFamily:'Source Sans Pro'},
    bigAvatar: {
        maxWidth: '900px',
        height: '91%',
        display: 'inline-block',
        marginTop: '3%',
        margin: '5px 5px 5px 5px',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        width: 158,
        height: 158
        
    },
  dropdownButton: {
    backgroundColor: '#2aa9a3',
    opacity:'0.9',
    width: '100%',
    maxWidth: '1000px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    margin: '0 auto',
  },
  dropdownButton1: {
    backgroundColor: '#55c5c1',
    opacity:'0.9',
    width: '100%',
    maxWidth: '1000px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    cursor: 'pointer',
    margin: '0 auto',
  },
   dropdownButton2: {
    backgroundColor:  '#79e2df',
    opacity:'0.9',
    width: '100%',
    maxWidth: '1000px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    cursor: 'pointer',
    margin: '0 auto',
  },
  dropdownContent: {
    width: '100%',
    maxWidth: '900px',
    marginTop: '1px',
    borderRadius: '5px',
    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.3)',
    background: 'rgba(255, 255, 255, 0.7)',
    margin: '0 auto',
  },
  dropdownContentExtern: {
    width: '100%',
    maxWidth: '1150px',
    marginTop: '1px',
    margin: '0 auto',
  },
 titleContent: {
  width: '100%',
  maxWidth: '1000px',
  margin: '20px 13% 0', /* Cambiar el valor de margen superior según tus necesidades */
  borderRadius: '20px',
  boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.3)',
  justifyContent: 'center',
  alignItems: 'center',
  maxHeight: '200px',
  display:'inline-block'
},
  title2: {
//        color: 'rgb(32 122 126)'
        color:'white',
        fontFamily: 'TovariSans'
    },
  body: {
      
    fontFamily: 'Gil Sans MT',
      fontSize:'16px',
      textAlign:'justify',
  }
  
})

export default function ScreenConozcanos() {
    const [message, setMessage] = React.useState([])
    const [openSuccess, setOpenSuccess] = React.useState(false)
    const classes = useStyles()
    const [propertiesData, setPropertiesData] = React.useState([]);
   
  const [expandedNuestraHistoria, setExpandedNuestraHistoria] = useState(false);
    
  const handleExpandNuestraHistoria = () => {
    setExpandedNuestraHistoria(!expandedNuestraHistoria);
  };
   const [expandedNuestraMision, setExpandedNuestraMision] = useState(true);
    
  const handleExpandNuestraMision = () => {
    setExpandedNuestraMision(!expandedNuestraMision);
  };
  
  const [expandedOtro, setExpandedOtro] = useState(false);
    
  const handleExpandOtro = () => {
    setExpandedOtro(!expandedOtro);
  };
  
   const [expandedEducacion, setExpandedEducacion] = useState(false);
    
  const handleExpandEducacion = () => {
    setExpandedEducacion(!expandedEducacion);
  };
  
  const [expandedInvestigacion, setExpandedInvestigacion] = useState(false);
    
  const handleExpandInvestigacion = () => {
    setExpandedInvestigacion(!expandedInvestigacion);
  };
  
   const [expandedRehabilitacion, setExpandedRehabilitacion] = useState(false);
    
  const handleExpandRehabilitacion = () => {
    setExpandedRehabilitacion(!expandedRehabilitacion);
  };
    function handleCloseMsj() {
        setOpenSuccess(false)
    }
    async function loadPropertiesFile() {
        try {
          const response = await axios.get('textos/screenConozcanos.properties');
          const fileContent = response.data;
          // Analiza el contenido del archivo utilizando properties-parser
          setPropertiesData(properties.parse(fileContent));
          return propertiesData;
        }catch (error) {
            console.error('Error loading properties file:', error);
            return null;
        }
    }
    
    useEffect(() => {
        async function fetchData() {
            const propertiesData = await loadPropertiesFile();
        }fetchData();
    }, []);
    
    return (
            
    <div class="restOfScreenForConozcanosScreen" >
        <Container> 
           <div class="col center">
            <div className={classes.card}>
            <CardContent className={classes.grid}>
             <Grid
                container
                spacing={0}
                alignItems='center'
                justify='center'
                textOverflow='hidden'
                className={classes.grid}
            >
           {/*<div style={{ backgroundImage: 'url("/images/conozcanos/karumbe_conozcanos.jpg")', width: '100%',backgroundSize: 'cover', borderRadius: '5px'}}>*/}
             <Table   className={classes.table} >
                <TableBody>
                    <TableRow >
                        <TableCell align='center' >
                            <Typography className={classes.title2} style={{color:'white'}}  variant='h4'>
                                QUÉ ES KARUMBÉ
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {/*</div>*/}
            <div>
                <div className="ns-dropdown-button" >
                 <div style={{ position: 'relative', height: '73%',textAlign:'center',marginLeft:'10px',marginRight:'10px' }}>
                    <Typography className={classes.title1} variant="h5" style={{ color: 'white'}}>
                        {propertiesData['subtitulo.quienes.somos']}<p/>
                    </Typography>
                    </div>
                </div>
                <Collapse  in={expandedOtro}>
                    <div  className={classes.dropdownContent}>
                      <Card style={{backgroundColor:'rgba(255, 255, 255, 0.7)'}}>
                        <CardContent>
              
                           <Typography  className={classes.body} >                  
                                {propertiesData['cuerpo.quienes.somos']}<p/> 
                            </Typography>
                        </CardContent>
                      </Card>
                    </div>
                </Collapse>
                
            </div>
            <div >
                <div className={classes.dropdownButton1} onClick={handleExpandNuestraHistoria}>
                 <div style={{ position: 'relative', height: '73%' }}>
                    <Typography className={classes.title1} variant="h5" style={{ color: 'white' }}>
                        {propertiesData['titulo.nuestra.historia']}<p/>
                    </Typography>
                    </div>
                    <ExpandMoreIcon style={{ marginLeft: '5px' }} />
                </div>
                <Collapse  in={expandedNuestraHistoria}>
                    <div  className={classes.dropdownContent}>
                      <Card style={{backgroundColor:'rgba(255, 255, 255, 0.7)'}}>
                        <CardContent style={{paddingBottom:'6px'}}>
                           <Typography  className={classes.body} >                  
                                {propertiesData['cuerpo.quienes.somos']}<p/> 
                            </Typography>
                        </CardContent>
                      </Card>
                    </div>
                </Collapse>
            </div>
            <div>
                <div className={classes.dropdownButton2} onClick={handleExpandNuestraMision}>
                 <div style={{ position: 'relative', height: '73%' }}>
                    <Typography className={classes.title1} variant="h5" style={{ color: 'white' }}>
                     {propertiesData['titulo.mision']}<p/>
                    </Typography>
                    
                    </div>
                    <ExpandMoreIcon style={{ marginLeft: '5px' }} />
                </div>
                <Collapse  in={expandedNuestraMision}>
                    <div  className={classes.dropdownContent}>
                        <Card style={{backgroundColor:'rgba(255, 255, 255, 0.7)'}}>
                          <CardContent style={{paddingBottom:'16px'}}>
                             <Typography  className={classes.body} >
                                  {propertiesData['cuerpo.mision']}
                              </Typography>
                          </CardContent>
                        </Card>
                    </div>
                </Collapse>
            </div>

              
          </Grid>
          </CardContent>
           </div>
            </div>
        </Container>  

        </div>
        )
}